import type { StartSignProcessDto } from '@cencert/mob-signature'
import { getConfig } from '../../config'

export const createQuerySet = (qrCode: StartSignProcessDto) => {
  const { testHash } = getConfig()
  if (testHash) {
    return `${qrCode?.externalProcessId},${qrCode?.providerId},${testHash}`
  }

  return `${qrCode?.externalProcessId},${qrCode?.providerId}`
}

export const createDeeplinkUrl = (qrCode: StartSignProcessDto) => {
  const config = getConfig()
  const appName = config.deeplinkAppName ?? 'mobywatel'

  const querySet = createQuerySet(qrCode)

  const base64Token = window.btoa(querySet)

  return `${appName}://eqsig?token=${base64Token}`
}
